import { action, createAsyncAction, getType } from 'typesafe-actions';

import type {
  OnboardingContract,
  OnboardingContractSignature,
  OnboardingContractType,
} from '@evenfinancial/finance-client';

import type { PortalError } from '@portal/common';

import type { IsomorphicRequestPayload } from '../types';

import { OnboardingContractActionType } from './actionTypes';

export interface OnboardingContractSignaturesCreate {
  types: OnboardingContractType[];
}

export const getAllOnboardingContractsAction = createAsyncAction(
  OnboardingContractActionType.GET_ALL_ONBOARDING_CONTRACTS_REQUEST,
  OnboardingContractActionType.GET_ALL_ONBOARDING_CONTRACTS_SUCCESS,
  OnboardingContractActionType.GET_ALL_ONBOARDING_CONTRACTS_FAILURE
)<IsomorphicRequestPayload, OnboardingContract[], PortalError>();

export const getSignedOnboardingContractsAction = createAsyncAction(
  OnboardingContractActionType.GET_SIGNED_ONBOARDING_CONTRACTS_REQUEST,
  OnboardingContractActionType.GET_SIGNED_ONBOARDING_CONTRACTS_SUCCESS,
  OnboardingContractActionType.GET_SIGNED_ONBOARDING_CONTRACTS_FAILURE
)<IsomorphicRequestPayload, OnboardingContractSignature[], PortalError>();

export const signOnboardingContractsAction = createAsyncAction(
  OnboardingContractActionType.SIGN_ONBOARDING_CONTRACT_REQUEST_CLIENT,
  OnboardingContractActionType.SIGN_ONBOARDING_CONTRACT_SUCCESS_CLIENT,
  OnboardingContractActionType.SIGN_ONBOARDING_CONTRACT_FAILURE_CLIENT
)<
  OnboardingContractSignaturesCreate,
  OnboardingContractSignature,
  PortalError
>();

export const onboardingContractsSave = (
  onboardingContracts: OnboardingContract[]
) => {
  return action(
    getType(getAllOnboardingContractsAction.success),
    onboardingContracts
  );
};

export const signedOnboardingContractSave = (
  onboardingContractsSignature: OnboardingContractSignature[]
) =>
  action(
    getType(getSignedOnboardingContractsAction.success),
    onboardingContractsSignature
  );
